import { type ProtocolDisplayInfo, getProtocolDisplayName } from '@/utils/protocol'
import { getProtocolImage } from '@vaultsfyi/common/utils'
import { RoundImage } from './roundImage'

interface ProtocolImageProps {
  protocol: ProtocolDisplayInfo
  className?: string
}

export const ProtocolImage = ({ protocol, className }: ProtocolImageProps) => {
  return (
    <RoundImage
      src={getProtocolImage(protocol.name)}
      fallback={getProtocolImage('fallback')}
      alt={getProtocolDisplayName(protocol)}
      className={className}
    />
  )
}
